import React, { useEffect, useState } from "react";
import styled from "styled-components";
import InfoCard from "../../components/account/InfoCard";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../hooks/useRequest";
import { Skeleton } from "@mui/material";
import { data } from "../../constants/IconsWithTextData";

const AccountStyle = styled.div`
  width: 100%;
  .page__title {
    color: #000;
    font-size: 27px;
    font-weight: 700;
    line-height: 34px;
    margin-bottom: 24px;
  }
  .account__info__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 24px;
    row-gap: 32px;
  }
  @media (max-width: 786px) {
    .page__title {
      font-size: 24px;
    }
    .account__info__grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

const Account = () => {
  const navigate = useNavigate();
  const [
    fetchAccount,
    { isLoading: isFetchingAccountData, state: accountState },
  ] = useRequest();

  const [fetchSavedProducts, { isLoading: list_loading }] = useRequest();
  const [totalSavedProducts, setTotalSavedProducts] = useState(0);

  const handleSavedProducts = async () => {
    const response = await fetchSavedProducts({
      path: `/wishlist?limit=100&page=1`,
    });
    if (response.success) {
      var reducedNumber = 0;
      if (response.data.length > 1) {
        reducedNumber = response.data.reduce(
          (a, b) => a?.items?.length + b?.items?.length
        );
      } else if (response.data.length === 1) {
        reducedNumber = response?.data[0]?.items?.length;
      }
      setTotalSavedProducts(reducedNumber);
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    handleSavedProducts();
  }, []);

  const [fetchAddress, { isLoading: isFetchingAddress }] = useRequest();
  const [defaultAddress, setDefaultAddress] = useState("");

  const callerFunc = async () => {
    const response = await fetchAddress({
      path: `/address/default`,
    });
    setDefaultAddress(response.data);
  };
  const [fetchReward] = useRequest();
  const [reward, setReward] = useState(0);

  const callerFunc2 = async () => {
    const response = await fetchReward({
      path: `/reward`,
    });
    setReward(response.data.reward);
  };

  useEffect(() => {
    callerFunc();
    callerFunc2();
  }, []);

  const accountData = [
    {
      title: `Hi ${accountState?.data?.name}`,
      subtitle:
        accountState?.data?.ibID && `IB ID: ${accountState?.data?.ibID}`,
      sub1: accountState?.data?.businessName,
      sub2: accountState?.data?.email,
      sub3: accountState?.data?.phone,
      buttonText: `Edit Profile Information`,
      onClick: () => {
        navigate("/account/profile-information");
      },
      cap: true,
    },
    {
      title: `IB Rewards`,
      sub1: `View your IB rewards.`,
      sub2: "$" + reward,
      buttonText: `View Rewards`,
      onClick: () => {
        navigate("/account/reward-history");
      },
    },
    {
      title: `Order Drafts`,
      sub1: `Add order drafts, monitor updated shipping costs, and only pay to confirm orders`,
      buttonText: `View Order Drafts Tracking`,
      onClick: () => {
        navigate("/account/order-drafts");
      },
    },
    {
      title: `Instabuild Pro History`,
      sub1: `Add receipts and keep track of your online and in-store purchases.`,
      buttonText: `View Purchase History`,
      onClick: () => {
        navigate("/account/instabuild-purchase-history");
      },
      comingSoon: true,
    },
    {
      title: `Group Buy History`,
      sub1: `Add receipts and keep track of your online and in-store purchases.`,
      buttonText: `View Purchase History`,
      onClick: () => {
        navigate("/account/groupbuy-purchase-history");
      },
    },
    {
      title: `Purchase History`,
      sub1: `Add receipts and keep track of your online and in-store purchases.`,
      buttonText: `View Purchase History`,
      onClick: () => {
        navigate("/account/purchase-history");
      },
    },
    {
      title: `My Wishlist`,
      sub1: `You have saved ${totalSavedProducts} product${
        totalSavedProducts > 1 ? "s" : ""
      }.`,
      buttonText: `View My Wishlist`,
      onClick: () => {
        navigate("/account/lists");
      },
    },
    {
      title: `My Addresses`,
      sub1: `Add and manage your addresses`,
      sub2: defaultAddress ? `${defaultAddress?.address}, ${defaultAddress?.city}, ${defaultAddress?.province}, ${defaultAddress?.pincode}` : "",
      buttonText: `View My Address`,
      onClick: () => {
        navigate("/account/address");
      },
    },
    {
      title: `Help & Support`,
      sub1: `Need help related to orders`,
      buttonText: `Contact Support`,
      onClick: () => {
        navigate("/account/help-support");
      },
    },
    {
      title: `Resolution Center`,
      sub1: `View all of your raised ticket here`,
      buttonText: `View Resolution Center`,
      onClick: () => {
        navigate("/account/tickets");
      },
    },
  ];

  useEffect(() => {
    async function fetchAccountDetails() {
      const path = `/account`;
      await fetchAccount({ path });
    }
    fetchAccountDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccountStyle>
      <div className="container">
        <div className="page__title">My Account</div>
        <div className="account__info__grid">
          {!isFetchingAccountData ? (
            <>
              {accountData?.map((data) => (
                <InfoCard key={data?._id} {...data} />
              ))}
            </>
          ) : (
            Array.from({ length: 6 }, (_, index) => (
              <Skeleton
                variant="rectangle"
                key={index + 1}
                height={200}
                width={"100%"}
              />
            ))
          )}
        </div>
      </div>
    </AccountStyle>
  );
};

export default Account;
